var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"size":"small"}},[_c('ButtonLinkOverview',{attrs:{"id":_vm.anchorName,"alignment":_vm.alignment,"elements":_vm.elements}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }